// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css */

/* Global styles */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: #f0f0f0;
}

.container {
  max-width: 960px; /* Adjust as needed */
  margin: 0 auto;
  padding: 20px;
}


header h1 {
  margin: 0;
  font-size: 24px;
}

/* Navigation styles */
nav {
  background-color: #333;
}

nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: center;
}

nav ul li {
  display: inline;
}

nav ul li a {
  display: inline-block;
  padding: 10px 20px;
  color: #fff;
  text-decoration: none;
}

nav ul li a:hover {
  background-color: #555;
}

/* Page content styles */
.page-content {
  padding: 20px;
}

/* Form styles */
.form-container {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.form-container h2 {
  margin-top: 0;
}

.form-container label {
  font-weight: bold;
}

.form-container input[type="text"],
.form-container input[type="email"],
.form-container input[type="password"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-container select {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-container input[type="submit"] {
  width: 100%;
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.form-container input[type="submit"]:hover {
  background-color: #45a049;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* Footer styles */
footer {
  background-color: #333;
  color: #fff;
  padding: 20px 0;
  text-align: center;
}

.or-divider {
  text-align: center;
  margin: 20px 0;
}
 
.or-divider span {
  background-color: #ffffff;
  color: #000000;
  padding: 10px 20px;
  border-radius: 50%;
  border: 1px solid #cccccc;
}

.custom-facebook-button {
  font-size: 15px; 
  padding: 10px 10px; 
  background-color: #ffffff;
  border: 1px solid #cccccc;
  width:175px;

}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,YAAY;;AAEZ,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB,EAAE,qBAAqB;EACvC,cAAc;EACd,aAAa;AACf;;;AAGA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;;AAEb","sourcesContent":["/* App.css */\n\n/* Global styles */\nbody {\n  font-family: Arial, sans-serif;\n  margin: 0;\n  padding: 0;\n  background-color: #f0f0f0;\n}\n\n.container {\n  max-width: 960px; /* Adjust as needed */\n  margin: 0 auto;\n  padding: 20px;\n}\n\n\nheader h1 {\n  margin: 0;\n  font-size: 24px;\n}\n\n/* Navigation styles */\nnav {\n  background-color: #333;\n}\n\nnav ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n\nnav ul li {\n  display: inline;\n}\n\nnav ul li a {\n  display: inline-block;\n  padding: 10px 20px;\n  color: #fff;\n  text-decoration: none;\n}\n\nnav ul li a:hover {\n  background-color: #555;\n}\n\n/* Page content styles */\n.page-content {\n  padding: 20px;\n}\n\n/* Form styles */\n.form-container {\n  max-width: 400px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.form-container h2 {\n  margin-top: 0;\n}\n\n.form-container label {\n  font-weight: bold;\n}\n\n.form-container input[type=\"text\"],\n.form-container input[type=\"email\"],\n.form-container input[type=\"password\"] {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.form-container select {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.form-container input[type=\"submit\"] {\n  width: 100%;\n  background-color: #4caf50;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.form-container input[type=\"submit\"]:hover {\n  background-color: #45a049;\n}\n\n.error-message {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* Footer styles */\nfooter {\n  background-color: #333;\n  color: #fff;\n  padding: 20px 0;\n  text-align: center;\n}\n\n.or-divider {\n  text-align: center;\n  margin: 20px 0;\n}\n \n.or-divider span {\n  background-color: #ffffff;\n  color: #000000;\n  padding: 10px 20px;\n  border-radius: 50%;\n  border: 1px solid #cccccc;\n}\n\n.custom-facebook-button {\n  font-size: 15px; \n  padding: 10px 10px; \n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  width:175px;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
